import React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';

import { TextsView } from './texts-view';

function textsViewRoute(routeProps: RouteComponentProps) {
  return (
    <Route
      path={`${routeProps.match.path}/view/:id`}
      render={() => (
        <>
          <TextsView />
        </>
      )}
    />
  );
}

export { textsViewRoute };
